export default function initNativeBlock() {}
